import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import ErrorPage from '@zocdoc-frontend-common/components-errorpage';
import Header from '@zocdoc-frontend-common/components-header';
import Page from '@zocdoc-frontend-common/components-page';
import PaddedContainer from '@zocdoc-frontend-common/components-padded-container';
import Footer from '@zocdoc-frontend-common/components-footer';

import parseError from './parseError';

export class ErrorView extends PureComponent {
    static propTypes = {
        errorCode: PropTypes.number,
        errorMessage: PropTypes.string,
    };

    static defaultProps = {
        errorCode: typeof window !== 'undefined' ? window.__ERROR_CODE__ : 500,
        errorMessage: typeof window !== 'undefined' ? window.__ERROR__ : '',
    };

    render() {
        return (
            <Page>
                <Header />

                <PaddedContainer>
                    <ErrorPage statusCode={this.props.errorCode} />
                    {this.maybeRenderError()}
                </PaddedContainer>

                <Footer />
            </Page>
        );
    }

    maybeRenderError() {
        if (process.env.NODE_ENV !== 'production') {
            return (
                <ErrorMessage>
                    {parseError(this.props.errorMessage)}
                </ErrorMessage>
            );
        }
    }
}

const ErrorMessage = styled.pre`
    margin-bottom: 10vh;
    white-space: pre-wrap;
`;

export default flowRight([hot(module)])(ErrorView);
